import { useMemo } from 'react';
import { useGetPatientContactsQuery } from '~/store/services/patients';
import { useGetGroupedAssessmentsQuery } from '~/store/services/assessments';
import {
  deriveEmergencyContactAlert,
  deriveSafetyPlanAlertFromCssrs,
} from '~/lib/util/patientAlerts.util';
import { PatientAlert } from '~/lib/types/patient/PatientAlert';

const usePatientAlerts = (
  patientId: string,
  patientPreferredFullName: string,
  genderOnRecord: string,
): PatientAlert[] => {
  const { data: groupedAssessments } = useGetGroupedAssessmentsQuery(
    { patientId },
    { skip: !patientId },
  );

  const { data: patientContactList } = useGetPatientContactsQuery(patientId, {
    skip: !patientId,
  });

  const patientAlerts = useMemo(() => {
    const surveyAlerts = groupedAssessments?.surveys
      ? deriveSafetyPlanAlertFromCssrs(
          groupedAssessments.surveys,
          patientPreferredFullName,
          genderOnRecord,
        )
      : [];

    const contactAlerts = patientContactList
      ? deriveEmergencyContactAlert(
          patientContactList.some((c) => c.isEmergencyContact),
          patientPreferredFullName,
        )
      : [];

    return [...surveyAlerts, ...contactAlerts];
  }, [
    genderOnRecord,
    groupedAssessments,
    patientContactList,
    patientPreferredFullName,
  ]);

  return patientAlerts;
};

export default usePatientAlerts;
